<template>
    <Form
      :show-message="showMessage"
      :model="actionData"
      >
      <FormItem prop="reportType">
        <van-radio-group v-model="actionData.reportType" slot-scope="scope">
            <van-radio name="0" icon-size=".7rem" checked-color="#d9b581">不感兴趣</van-radio>
            <van-radio name="1" icon-size=".7rem" checked-color="#d9b581">此类内容太多</van-radio>
            <van-radio name="2" icon-size=".7rem" checked-color="#d9b581">浏览过</van-radio>
            <van-radio name="3" icon-size=".7rem" checked-color="#d9b581">其他</van-radio>
            </van-radio-group>
      </FormItem>
      <FormItem prop="reason" class="textarea">
        <i-input type="textarea" v-model="actionData.reason" placeholder="屏蔽理由" :rows="5"/>
      </FormItem>
    </Form>
  </template>
  
  <script type="text/javascript">
  export default {
    data () {
      return {
        // url: 'topic/report',
        actionData: {
          topicId: this.selection.topicId,
          replyId: this.selection.replyId,
          reportType: undefined,
          reason: ''
        }
      }
    },
    computed: {
      rules () {
        return {
          reason: {
            required: true,
            message: '请填写原因'
          }
        }
      }
    },
    methods: {
      _validate() {
          return new Promise((resolve, reject) => {
            const {reportType,reason} = this.actionData;
            if (!reportType) {
                reject(new Error("请选择屏蔽原因"));
              return
            }else {
                this.$Message.success('屏蔽成功')
                this.$emit("success");
            }
          });
        }
    },
  }
  </script>
  
  <style lang="less" scoped>
    
  </style>
  